/** Bestandsübernahme aus einer CSV. */

import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from './klient'

export type Importhinweis = {
  zeile: number
  feld: string
  text: string
  schwer: boolean
}

export type Importergebnis = {
  probelauf: boolean
  zeilen: number
  kunden_neu: number
  kunden_bekannt: number
  plaetze_neu: number
  plaetze_bekannt: number
  geraete_neu: number
  geraete_bekannt: number
  kontakte_neu: number
  faelligkeiten_neu: number
  uebersprungen: number
  unbekannte_spalten: string[]
  hinweise: Importhinweis[]
  weitere_hinweise: number
}

export function useCsvEinlesen() {
  const speicher = useQueryClient()
  return useMutation({
    mutationFn: ({ datei, probelauf }: { datei: File; probelauf: boolean }) => {
      const form = new FormData()
      form.append('datei', datei)
      return api.hochladen<Importergebnis>(
        `/api/uebernahme/csv?probelauf=${probelauf}`,
        form,
      )
    },
    onSuccess: (ergebnis) => {
      // Nur nach einem echten Lauf: ein Probelauf hat nichts geändert, und
      // ein Neuladen aller Listen wäre dann verschenkte Arbeit.
      if (!ergebnis.probelauf) {
        void speicher.invalidateQueries({ queryKey: ['kunden'] })
        void speicher.invalidateQueries({ queryKey: ['spielplaetze'] })
        void speicher.invalidateQueries({ queryKey: ['aufgaben'] })
      }
    },
  })
}
